import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useSmartNavigate from 'hooks/useSmartNavigate';
import useCustomer from 'hooks/useCustomer';
import { loadingStatus } from 'helpers/fetcher';
import Icon from 'components/Icon';

const STORE_ID_MOSCOW = 1;
const PAGE_DELIVERY_NALCHIK = '/page/15';
const PAGE_DELIVERY_MOSCOW = '/page/16';

const FooterLayout = () => {
	const { t } = useTranslation();
	const { data, status } = useSelector(state => state.layout.mainInfo);
	const { navigate } = useSmartNavigate();
	const { customer } = useCustomer();
	const deliveryPage =
		customer?.store_id === STORE_ID_MOSCOW
			? PAGE_DELIVERY_MOSCOW
			: PAGE_DELIVERY_NALCHIK;

	return (
		<div
			className='rn-footer'
			style={{
				backgroundImage: `url(${
					process.env.PUBLIC_URL || ''
				}/images/bg-footer.webp)`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
			}}
		>
			<div className='footer-content'>
				<div className='footer-main'>
					{/* Левая колонка */}
					<div className='footer-column footer-column-left'>
						<Icon
							name='logo'
							className='footer-logo'
							ariaLabel={t('common.rayan')}
							ariaHidden={false}
						/>
						<p className='footer-subtitle'>{t('footer.onlineStore')}</p>
						{status === loadingStatus.SUCCEEDED && data.telephone ? (
							<a href={`tel:${data.telephone}`} className='footer-phone'>
								{data.telephone}
							</a>
						) : (
							<a href='tel:+79182494242' className='footer-phone'>
								+7 (918) 249 42-42
							</a>
						)}
						<p className='footer-label'>{t('footer.qualityService')}</p>
						{status === loadingStatus.SUCCEEDED && data.email_quality ? (
							<a href={`mailto:${data.email_quality}`} className='footer-email'>
								{data.email_quality}
							</a>
						) : (
							<a
								href='mailto:hygienequality@rayanhalal.ru'
								className='footer-email'
							>
								hygienequality@rayanhalal.ru
							</a>
						)}
					</div>

					{/* Колонки справа */}
					<div className='footer-columns-right'>
						{/* 2 колонка */}
						<div className='footer-column'>
							<ul className='footer-links'>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/9');
										}}
										className='footer-link-bold'
									>
										{t('header.vacancies')}
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/contact');
										}}
									>
										{t('header.leaveReview')}
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/news');
										}}
									>
										{t('header.news')}
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/20');
										}}
									>
										{t('header.certificates')}
									</a>
								</li>
							</ul>
						</div>

						{/* 3 колонка */}
						<div className='footer-column'>
							<ul className='footer-links'>
								{/* Акции (временно скрыто)
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/promotions');
										}}
									>
										<Icon name='icon-percent-badge' className='footer-link-icon' />
										Акции
									</a>
								</li>
								*/}
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/4');
										}}
									>
										<Icon
											name='icon-info-circle'
											className='footer-link-icon'
										/>
										{t('header.aboutCompany')}
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate(deliveryPage);
										}}
									>
										<Icon
											name='icon-shipping-fast'
											className='footer-link-icon'
										/>
										{t('header.deliveryAndPayment')}
									</a>
								</li>
								<li>
									<a
										href='https://is.rayanhalal.ru/'
										target='_blank'
										rel='noopener noreferrer'
									>
										<svg className='footer-link-icon' viewBox='0 0 20 20' aria-hidden='true'>
											<path d='M3 6.2L10 3.2L17 6.2V13.8L10 16.8L3 13.8V6.2Z' fill='none' stroke='#fff' strokeWidth='1.4' strokeLinejoin='round' />
											<path d='M3 6.2L10 9.2L17 6.2' fill='none' stroke='#fff' strokeWidth='1.4' strokeLinejoin='round' />
											<path d='M10 9.2V16.8' fill='none' stroke='#fff' strokeWidth='1.4' strokeLinejoin='round' />
										</svg>
										{t('header.wholesale')}
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/contact');
										}}
									>
										<Icon
											name='icon-envelope-footer'
											className='footer-link-icon'
										/>
										{t('header.contacts')}
									</a>
								</li>
							</ul>
						</div>

						{/* 4 колонка */}
						<div className='footer-column'>
							<ul className='footer-links'>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/stores');
										}}
									>
										{t('footer.storesAndCafes')}
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/6');
										}}
									>
										{t('footer.howToPay')}
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate(deliveryPage);
										}}
									>
										{t('footer.deliveryMethod')}
									</a>
								</li>
							<li>
								<a
									href='#'
									onClick={e => {
										e.preventDefault();
										navigate('/reviews');
									}}
								>
									{t('footer.reviews')}
								</a>
							</li>
							<li>
								<a
									href='#'
									onClick={e => {
										e.preventDefault();
										navigate('/privacy');
									}}
								>
									{t('footer.privacyPolicy')}
								</a>
							</li>
						</ul>
					</div>
					</div>
				</div>

				{/* Иконки соцсетей и платежных систем */}
				<div className='footer-bottom'>
					<div className='footer-social'>
						<a href='#' className='footer-social-link'>
							<Icon name='Telegram' ariaLabel='Telegram' ariaHidden={false} />
						</a>
						<a href='#' className='footer-social-link'>
							<Icon name='VK' ariaLabel='VK' ariaHidden={false} />
						</a>
						<a href='#' className='footer-social-link'>
							<Icon name='WhatsApp' ariaLabel='WhatsApp' ariaHidden={false} />
						</a>
					</div>
					<div className='footer-apps'>
						<a
							href='https://www.rustore.ru/catalog/app/com.rayanmobile'
							className='footer-app-link'
							target='_blank'
							rel='noopener noreferrer'
							aria-label='RuStore'
						>
							<svg viewBox='0 0 100 100' aria-hidden='true'>
								<path
									fillRule='evenodd'
									d='M48 100C25.3726 100 14.0589 100 7.02944 92.9705C0 85.9411 0 74.6273 0 51.9998L0 47.9997C0 25.3722 0 14.0585 7.02944 7.02904C14.0589 0 25.3726 0 48 0L52 0C74.6274 0 85.9411 0 92.9706 7.02904C100 14.0585 100 25.3722 100 47.9997L100 51.9997C100 74.6273 100 85.9411 92.9706 92.9705C85.9411 100 74.6274 100 52 100L48 100Z'
									fill='#2B71F6'
								/>
								<path d='M57.8261 61.6261C55.1318 60.953 53.2427 58.5429 53.2427 55.7787L53.2427 23.213C53.2427 20.0733 56.2095 17.7706 59.2697 18.5351L78.6493 23.3762C81.3436 24.0492 83.2327 26.4593 83.2327 29.2235L83.2327 61.7893C83.2327 64.929 80.2659 67.2317 77.2057 66.4672L57.8261 61.6261Z' fill='#fff' />
								<path d='M21.3505 76.6223C18.6562 75.9493 16.7671 73.5392 16.7671 70.775L16.7671 38.2092C16.7671 35.0695 19.7339 32.7669 22.7941 33.5313L42.1737 38.3724C44.868 39.0455 46.7571 41.4556 46.7571 44.2198L46.7571 76.7856C46.7571 79.9252 43.7903 82.2279 40.7301 81.4634L21.3505 76.6223Z' fill='#fff' />
								<path d='M39.5888 69.1243C36.8945 68.4512 35.0054 66.0411 35.0054 63.2769L35.0054 30.7112C35.0054 27.5715 37.9722 25.2688 41.0324 26.0333L60.412 30.8744C63.1063 31.5474 64.9954 33.9575 64.9954 36.7218L64.9954 69.2875C64.9954 72.4272 62.0286 74.7299 58.9684 73.9654L39.5888 69.1243Z' fill='#fff' />
								<path d='M52.2724 72.3017C51.4238 72.0856 50.8198 71.3351 50.7901 70.4599L49.947 45.5896C49.7031 42.298 47.2598 39.6802 44.7064 38.9092C44.5631 38.8659 44.41 38.9242 44.3251 39.0476C44.2388 39.1729 44.2721 39.3464 44.3925 39.4396C45.023 39.9276 46.7584 41.5205 46.7584 44.2678L46.7532 70.9031L52.2724 72.3017Z' fill='#2B71F6' />
								<path d='M70.5142 64.797C69.6663 64.5848 69.0616 63.8366 69.0319 62.963L68.1887 38.0945C67.9448 34.8029 65.5015 32.185 62.9481 31.4141C62.8048 31.3708 62.6517 31.4291 62.5668 31.5524C62.4805 31.6778 62.5138 31.8513 62.6342 31.9445C63.2647 32.4325 65.0001 34.0253 65.0001 36.7727L64.995 63.4171L70.5142 64.797Z' fill='#2B71F6' />
							</svg>
							<span>RuStore</span>
						</a>
						<a
							href='https://play.google.com/store/apps/details?id=com.rayanmobile'
							className='footer-app-link'
							target='_blank'
							rel='noopener noreferrer'
							aria-label='Google Play'
						>
							<svg viewBox='0 0 48 48' aria-hidden='true'>
								<rect width='48' height='48' rx='12' fill='#fff' />
								<svg x='9.2' y='7.7' width='29.6' height='32.6' viewBox='0 0 28.99 31.99'>
									<path d='M13.54 15.28.12 29.34a3.66 3.66 0 0 0 5.33 2.16l15.1-8.6Z' fill='#ea4335' />
									<path d='m27.11 12.89-6.53-3.74-7.35 6.45 7.38 7.28 6.48-3.7a3.54 3.54 0 0 0 1.5-4.79 3.62 3.62 0 0 0-1.5-1.5z' fill='#fbbc04' />
									<path d='M.12 2.66a3.57 3.57 0 0 0-.12.92v24.84a3.57 3.57 0 0 0 .12.92L14 15.64Z' fill='#4285f4' />
									<path d='m13.64 16 6.94-6.85L5.5.51A3.73 3.73 0 0 0 3.63 0 3.64 3.64 0 0 0 .12 2.65Z' fill='#34a853' />
								</svg>
							</svg>
							<span>Google Play</span>
						</a>
						<a
							href='https://apps.apple.com/us/app/%D0%BC%D0%B4-%D1%80%D0%B0%D0%B9%D1%8F%D0%BD/id6761650691'
							className='footer-app-link'
							target='_blank'
							rel='noopener noreferrer'
							aria-label='App Store'
						>
							<svg viewBox='0 0 48 48' aria-hidden='true'>
								<rect width='48' height='48' rx='12' fill='#000' />
								<g transform='translate(8.5 8.5) scale(1.292)'>
									<path
										fill='#fff'
										d='M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701'
									/>
								</g>
							</svg>
							<span>App Store</span>
						</a>
					</div>
					<div className='footer-payments'>
						<Icon
							name='Visa'
							className='footer-payment-icon'
							ariaLabel='Visa'
							ariaHidden={false}
						/>
						<Icon
							name='Mastercard'
							className='footer-payment-icon'
							ariaLabel='Mastercard'
							ariaHidden={false}
						/>
						<Icon
							name='mir'
							className='footer-payment-icon'
							ariaLabel='Mir'
							ariaHidden={false}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FooterLayout;
